/**
 * A component that checks client's browser if the app version has changed.
 * If a version upgrade is detected, then the browser local storage is cleaned up.
 */
'use client'

import { useEffect } from 'react'

import { APP_VERSION } from '@/lib/version'

const LOCAL_STORAGE_KEY = 'data-dashboard-app-version'

export const AppVersionManager = () => {
  useEffect(() => {
    const storedVersion = localStorage.getItem(LOCAL_STORAGE_KEY)

    if (storedVersion !== APP_VERSION) {
      // App Version change is detected, clearing localStorage

      localStorage.clear()
      localStorage.setItem(LOCAL_STORAGE_KEY, APP_VERSION)
    }
  }, [])

  return null
}
